import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import * as styles from '@twisto/styles'

export const content = css`
  max-height: 30vh;
  min-height: ${styles.size[32]};
  border-radius: ${styles.borderRadius.md};
  margin-top: ${styles.size[8]};
  padding: ${styles.size[8]};

  overflow: auto;
  user-select: none;

  position: relative;
`

export const item = css`
  border-radius: ${styles.borderRadius.sm};
  padding: ${styles.size[4]} ${styles.size[12]};
`

export const clickable = (theme: Theme) => css`
  cursor: pointer;

  &:hover,
  &:focus {
    background-color: ${theme.palette.neutral[200]};
  }
  &:active {
    background-color: ${theme.palette.neutral[300]};
  }
`

export const activeItem = (theme: Theme) => css`
  background-color: ${theme.palette.neutral[300]};
`

export const root = css`
  position: absolute;
  width: 100%;
  z-index: 2;
`

// displays dropdown above the input
export const abovePositioned = css`
  bottom: calc(100% + ${styles.size[16]});
`

export const listRoot = css`
  display: grid;
  grid-auto-flow: row;
  row-gap: ${styles.size[4]};
  margin: ${styles.size[0]};
  padding: ${styles.size[0]};
  list-style: none;
`
